import { Route, Routes } from "react-router-dom";

import NotFound from "~/components/NotFound/NotFound";
import Landings from "./Landings";

const LandingsRouter = () => {
  return (
    <Routes>
      <Route index element={<Landings />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default LandingsRouter;
